export const Endpoint = () => `/api/v3/agent/delete/`;
export const Csrf = () => `/api/v3/agent/token/`;
export declare const QueryKey: never;
export type Payload = { id: string };
export type Response = void;
